document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const emTag = document.querySelector('.bss-b2b-rf-privacy-policy em');
    if (emTag) {
        emTag.textContent = 'Valider';
    }

    const submitBtn = document.querySelector('.bss-b2b-rf-submit-button input[type="submit"]');
    if (submitBtn) {
        submitBtn.value = 'Valider';
    }
  }, 1000);

  const btn = document.getElementById("bss-b2b-net-term-button");

  if (btn) {
    btn.addEventListener("click", function () {
      
      setTimeout(() => {
        const el = document.querySelector(".b2b-nt-modal-customer-contact-info p:last-of-type");
      if (el) {
        const match = el.textContent.match(/le (.+?)\s*\./); // find date
        if (match && match[1]) {
          const date = new Date(match[1]);
          if (!isNaN(date.getTime())) {
            const formatter = new Intl.DateTimeFormat("fr-FR", {
              day: "numeric",
              month: "long",
              year: "numeric",
            });
            const formatted = formatter.format(date); // ex: "4 septembre 2025"
            el.textContent = `Votre paiement est dû le ${formatted} .`;
          }
        }
      }
      }, 1000);
    });
  }

  if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('b2b-nt-modal-overlay')) {
            document.dispatchEvent(new Event("DOMContentLoaded"))
            const translations = {
              "in 7 days": "dans 7 jours",
              "in 15 days": "dans 15 jours",
              "in 30 days": "dans 30 jours",
              "in 60 days": "dans 60 jours",
              "in 90 days": "dans 90 jours",
              "on receipt": "à réception",
              "in 90 days": "dans 90 jours",
              "on fulfillment": "sur l'accomplissement",
            };

            document.querySelectorAll('span.bss-trans').forEach((el) => {
              const originalText = el.textContent.trim();
              if (translations[originalText]) {
                el.textContent = translations[originalText];
              }
            });
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }
});

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      for (let item of MutationList) {
        if (item.target.classList?.contains('button-container') || item.target.classList?.contains('mini-cart--opening')) {
          setTimeout(() => {
            BSS_B2B.observer.cartSubject.listenCartCheckout();
            document.dispatchEvent(new Event("DOMContentLoaded"))
          }, 1000);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }, 300);
}
